<template>
  <div class="valuation_information">
    <div class="vi_top">
      <div class="vi_top_left">
        <!-- <div class="vi_title"></div> -->
        <div class="vi_price">预估市场价 - <span>￥{{assess_price}}</span></div>
      </div>
      <router-link :to="{name:'SiteNotice'}" class="vi_top_right">返回</router-link>
    </div>
    <div class="vi-middle">
      <div class="vi-middle-left">
        <div class="VN_left_title"><img src="@/assets/image/AccountValuation/gj1.png"><span>官网寄售-建议市场预估价</span></div>
        <hr class="dividing_line"/>
        <ul class="VN_list">
          <li class="VN_list_one">游严选美工截取账号详情图，编辑标题挂售到官方网站（约30分钟）。</li>
          <li class="VN_list_two">平台在交流群等渠道同步宣传，提高曝光度以匹配更多买家。</li>
          <li class="VN_list_three">买家确认交易并完成付款，由客服拉群聊安排交易流程。</li>
          <li class="VN_list_four">买卖双方游戏资料交接完成后，财务实时放款，交易完成。</li>
        </ul>
        <div class="VN_price">
          <div class="assess_price">
            预估到手价：<span>￥{{assess_price}}</span>
          </div>
          <div class="tip" v-if="game_id!=8">
            平台估价价格仅供参考,一键寄售可自由挂售价格
          </div>
        </div>
        <div class="VN_left_btn_group" v-if="game_id!=8">
          <div class="btn-create-img" @click="createAssessImg" v-if="info.image_status !== 4">
            <i class="el-icon-caret-right"></i>{{ valuationBtnText }}
          </div>
          <div class="btn-fast-sell" @click="oneClickConsignment">
            <span>一键寄售</span>
            <span class="btn-fast-sell-tip">数据直接导入</span>
          </div>
<!--          <router-link :to="{name:'AccountSell',query:{product_id}}" @click="oneClickConsignment">一键寄售</router-link>-->
        </div>
      </div>
      <div class="vi-middle-center">
        <div class="VN_left_title"><img src="@/assets/image/AccountValuation/gj2.png"><span>担保中介-参考市场价自定价格</span></div>
        <hr class="dividing_line"/>
        <ul class="VN_list">
          <li class="VN_list_one">双方私下联系谈好价格，确认账号详情后联系游严选客服。</li>
          <li class="VN_list_two">客服直接拉组中介交易。</li>
          <li class="VN_list_three">担保中介不限游戏，支持市面所有游戏账号交易。</li>
        </ul>
        <hr class="dividing_line"/>
        <div class="VN_left_btn color-fff">
          <a @click="cusSerBtnClicks" href="#">联系客服</a>
          <!-- <a v-else @click="$accessLink(sell_customer)"
                 :href="`${sell_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`" target="_blank">联系客服</a> -->
        </div>
      </div>
      <div class="vi-middle-right">
        <div class="VN_left_title"><img src="@/assets/image/AccountValuation/gj3.png"><span>号商回收-一般是市场价的5-8折</span></div>
        <hr class="dividing_line"/>
        <ul class="VN_list">
          <li class="VN_list_one">号商对账号进行报价，号主决定是否回收。</li>
          <li class="VN_list_two">快速变现，当天收款。</li>
          <li class="VN_list_three">所有交易一律由官方客服拉组担保中介交易。</li>
          <li class="VN_list_four">合作号商并非游严选官方人员。</li>
        </ul>
        <hr class="dividing_line"/>
        <div class="VN_left_btn color-fff">
          <router-link :to="{name:'AccountRecycle',query:{game_id}}">联系客服</router-link>
        </div>
      </div>
    </div>
    <div class="vi-message">
      <div class="msg-top">
        <div class="msg-left">客服留言：</div>
        <div class="msg-right" @click="continueToValue">继续估价</div>
<!--        <router-link :to="{name:'AccountValuation'}" class="msg-right" @click="continueToValue">继续估价</router-link>-->
      </div>
      <div class="msg-con">{{assess_price_note}}</div>
    </div>
    <div class="vi_connect_box">
      <div class="vi_title">估价信息</div>
      <div class="vi_connect" v-html="game_name+' / '+valuationInfo">{{game_name}} / {{valuationInfo}}</div>
    </div>
    <myDialog
      title="提示"
      text="估价图片预计3分钟内生成，完成后可重新进入该页面进行查看"
      btn-text="确认"
      :show="showCreateImgDialog"
      :close-fun="() => showCreateImgDialog = false"
      :btn-fuc="() => showCreateImgDialog = false"
    ></myDialog>
  </div>
</template>

<script>
import {apiValuationDetail,apiGameListForValuation} from "@/request/API";
import { apicreateAssessImage } from '../../../request/API';
import myDialog from "@/components/myDialog";
export default {
  name:'ValuationInformation',
  components: {
    myDialog
  },
  data() {
    return {
      // 价格
      assess_price: '',
      // 详细信息
      valuationInfo: '',
      game_id: this.$route.query.game_id,
      game_name: '',
      // 客服留言
      assess_price_note: '',
      product_id: this.$route.query.product_id,
      sell_customer: '',
      sys_service_type: 0,
      red_ids:[],
      info: '',
      valuationBtnText: '',
      showCreateImgDialog: false
    }
  },
  methods:{
    pollValuationDetail() {
      setTimeout(() => {
        apiValuationDetail({
          id:this.product_id
        }).then(res => {
          if(res.code === 200) {
            this.info = res.data
            const valuationBtnTextList = ['生成估价图片', '图片生成中', '查看估价图片', '重新生成图片']
            this.valuationBtnText = valuationBtnTextList[this.info.image_status || 0]
            this.info.image_status === 1 && this.pollValuationDetail()
          }
        })
      }, 30000);
    },
    createAssessImg() {
      const status = this.info.image_status

      if([0, 3].includes(status)) {
        this.showCreateImgDialog = true
        this.info.image_status = 1
        apicreateAssessImage({id: this.info.id}).then(res=> {
          if (res.code === 200) {
            this.valuationBtnText = res.msg
            this.pollValuationDetail()
          } else {
            // 生成失败
            this.info.image_status = 0
          }
        })
      }
      if(status === 2) {
        this.$viewerApi({
          options: {
            toolbar: false,
          },
          images: [this.info.image_url],
        })
      }
    },
    cusSerBtnClicks() {
      this.$openIM({
        game_id: this.game_id,
      })
    },
    getGameData(){
      apiValuationDetail({
        id:this.product_id
      }).then(res => {
        this.info = res.data
        const valuationBtnTextList = ['生成估价图片', '图片生成中', '查看估价图片', '重新生成图片']
        this.valuationBtnText = valuationBtnTextList[this.info?.image_status || 0]
        this.red_ids = res.data.red_ids || []
        this.assess_price = res.data.assess_price
        this.assess_price_note = res.data.assess_price_note
        if(this.assess_price_note == '') this.assess_price_note ='暂无留言'
        this.game_id = res.data.game_id
        this.valuationInfo = res.data.category.map(obj => `${obj.cat_name}:${obj.attr.map(v=>`<span style="color:${this.red_ids.includes(v.id)?'red':''}">${v.name}</span>`)}`).join('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        if (res.data.game_id === 26 || res.data.game_id === 161) {
          if(res.data.role != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;角色：${res.data.role}`
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;武器：${res.data.arms}`
        }else if (res.data.game_id === 13){
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;皮肤总数：${res.data.skin_num}`
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;贵族等级：${res.data.nobility_level}`
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;背包剩余荣耀水晶数量：${JSON.parse(res.data.arms_data).honor_crystal}`
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大国标数：${JSON.parse(res.data.arms_data).big_nation}`
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;小国标数：${JSON.parse(res.data.arms_data).small_nation}`
        }else if(res.data.game_id === 130 || res.data.game_id === 148){
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;剩余R点：${res.data.skin_num}`
          if(res.data.arms != '') this.valuationInfo = this.valuationInfo + `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;剩余VP点：${res.data.hero_num}`
        }
        this.sell_customer = res.data.sell_customer
      })
      apiGameListForValuation().then(res => {
        res.data.forEach((item, index) => {
          if(item.game_id == this.game_id){
            this.game_name = item.game_name
            this.sys_service_type = item.sys_service_type
          }
        })
      })
    },

    /**
     * 一键寄售
     */
    oneClickConsignment(){
      this.$sensorsTrack.SellClick(
        this.info.id,
        this.game_name,
        this.game_id,
        this.info.assess_price * 1,
        this.info.assess_price_note,
        this.info.assess_id,
        this.info.assess_id_name,
      )
      this.$router.push({
        name:'AccountSell',
        query:{product_id:this.product_id}
      })
    },
    /**
     * 继续估价
     */
    continueToValue(){
      this.$sensorsTrack.ContinueValuationClick(
        this.info.id,
        this.game_name,
        this.game_id,
        this.info.assess_price * 1,
        this.info.assess_price_note,
        '',
        '',
      )
      this.$router.push({
        name:'AccountValuation',
      })
    }
  },
  mounted(){
    this.getGameData()
  }
}
</script>

<style lang="less" scoped>
.valuation_information{
  width: 1100px;
  margin-top: 25px;
  color: var(--text-main, #111827);
  .vi_top{
    min-height: 112px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 0 32px 0 36px;
    background: linear-gradient(135deg, var(--bg-card, #FFFFFF) 0%, var(--bg-section, #F7F5F2) 100%);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    box-sizing: border-box;
    position: relative;
    overflow: hidden;

    &::before{
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 5px;
      height: 100%;
      background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
    }

    .vi_top_left{
      .vi_price{
        color: var(--text-main, #111827);
        font-size: 24px;
        font-weight: 600;
        line-height: 34px;

        &::before{
          content: '估价结果';
          display: block;
          margin-bottom: 8px;
          color: var(--text-secondary, #5A5F6B);
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }

        span{
          color: var(--primary, #FF7A1A);
        }
      }
    }
    .vi_top_right{
      position: relative;
      z-index: 1;
      min-width: 88px;
      height: 36px;
      line-height: 34px;
      color: var(--brand-blue, #1A1D24);
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      background: var(--brand-blue-light, #F0EDE8);
      border: 1px solid rgba(26, 29, 36, 0.18);
      border-radius: 4px;
      box-sizing: border-box;
      transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

      &:hover{
        background: var(--bg-tag, #F0EDE8);
        border-color: var(--brand-blue, #1A1D24);
        transform: translateY(-1px);
      }
    }
  }
  .vi-middle{
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 16px;
    >div{
      flex: 1;
      min-height: 354px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      box-sizing: border-box;
      padding: 24px 22px;
      position: relative;
    }
    .dividing_line{
        margin: 0;
        background-color: var(--border-soft, #E8E4DE);
        border: none;
        height: 1px;
      }
      .VN_left_title{
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          img{
            width: 34px;
            height: 34px;
            margin-right: 11px;
            border-radius: 4px;
          }
          span{
            color: var(--text-main, #111827);
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
          }
        }
        .VN_list{
          padding-top: 20px;
          min-height: 158px;
          li{
            margin-bottom: 16px;
            padding-left: 30px;
            position: relative;
            color: var(--text-secondary, #5A5F6B);
            font-size: 14px;
            line-height: 22px;
            &.VN_list_one::before,&.VN_list_three::before,&.VN_list_four::before,&.VN_list_two::before{
              content: '1';
              display: inline-block;
              position: absolute;
              left: 0;
              top: 1px;
              border: 1px solid rgba(26, 29, 36, 0.18);
              width: 20px;
              height: 20px;
              text-align: center;
              border-radius: 50%;
              background: var(--brand-blue-light, #F0EDE8);
              color: var(--brand-blue, #1A1D24);
              font-size: 12px;
              line-height: 18px;
              box-sizing: border-box;
            }
            &.VN_list_two::before{
              content: '2';
            }
            &.VN_list_three::before{
              content: '3';
            }
            &.VN_list_four::before{
              content: '注';
              font-size: 12px;
              color: var(--warning, #F59E0B);
              background: var(--warning-soft, #FFFBEB);
              border-color: rgba(245, 158, 11, 0.32);
            }
          }
        }
        .VN_price{
          margin-top: 4px;
          padding: 14px 0;
          border-top: 1px solid var(--border-soft, #E8E4DE);
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
          line-height: 32px;
          .assess_price{
            color: var(--text-main, #111827);
            font-size: 15px;
            font-weight: 500;
            span{
              color: var(--primary, #FF7A1A);
              font-weight: 700;
              font-size: 24px;
            }
          }
          .tip{
            display: inline-block;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--brand-blue, #1A1D24);
            line-height: 20px;
            background: var(--brand-blue-light, #F0EDE8);
            border-radius: 4px;
            padding: 4px 10px;
            margin: 6px 0 0;
          }

        }
        .VN_left_btn{
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
          span{
            display: inline-block;
            line-height: 30px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: #bebebe;
          }
          div,a{
            cursor: pointer;
            display: inline-block;
            width: 122px;
            height: 36px;
            line-height: 34px;
            text-align: center;
            color: var(--brand-blue, #1A1D24);
            font-size: 14px;
            font-weight: 500;
            background: var(--brand-blue-light, #F0EDE8);
            border: 1px solid rgba(26, 29, 36, 0.18);
            border-radius: 4px;
            margin-left: 11px;
            box-sizing: border-box;
            transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

            &:hover{
              background: var(--bg-tag, #F0EDE8);
              border-color: var(--brand-blue, #1A1D24);
              transform: translateY(-1px);
            }
          }
        }
        .VN_left_btn_group {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          .btn-create-img {
            cursor: pointer;
            display: inline-block;
            line-height: 36px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 500;
            color: var(--brand-blue, #1A1D24);

            &:hover{
              color: #1A1D24;
            }
          }
          .btn-fast-sell {
            cursor: pointer;
            width: 136px;
            height: 52px;
            text-align: center;
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            background: var(--primary, #FF5A1F);
            border-radius: 4px;
            margin-left: 11px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
            transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

            &:hover{
              background: var(--primary-hover, #E84A12);
              box-shadow: 0 12px 24px rgba(255, 90, 31, 0.28);
              transform: translateY(-1px);
            }
            .btn-fast-sell-tip {
              font-size: 12px;
              font-weight: 400;
              color: rgba(255, 255, 255, .82);
            }
          }
        }
        .color-fff{
          a{
            background: var(--brand-blue-light, #F0EDE8);
            border: 1px solid rgba(26, 29, 36, 0.18);
            color: var(--brand-blue, #1A1D24);

            &:hover{
              border-color: var(--brand-blue, #1A1D24);
              color: var(--brand-blue, #1A1D24);
              background: var(--bg-tag, #F0EDE8);
            }
          }
        }
    .vi-middle-center{
      margin: 0;
    }
    .vi-middle-right{}
  }
  .vi-message{
    margin: 16px 0;
    min-height: 132px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    padding: 24px 30px;
    box-sizing: border-box;
    .msg-top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      .msg-left{
        font-size: 16px;
        font-weight: 600;
        color: var(--text-main, #111827);
      }
      .msg-right{
        cursor: pointer;
        display: inline-block;
        width: 122px;
        height: 36px;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        box-shadow: 0 10px 20px rgba(255, 90, 31, 0.22);
        transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        &:hover{
          background: var(--primary-hover, #E84A12);
          box-shadow: 0 12px 24px rgba(255, 90, 31, 0.28);
          transform: translateY(-1px);
        }
      }
    }
    .msg-con{
      min-height: 44px;
      color: var(--text-secondary, #5A5F6B);
      font-size: 14px;
      line-height: 24px;
    }
  }
  .vi_title{
    color: var(--text-main, #111827);
    font-size: 16px;
    font-weight: 600;
  }
  .vi_connect_box{
    min-height: 132px;
    padding: 24px 30px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    box-sizing: border-box;
    .vi_connect{
      margin-top: 12px;
      font-size: 14px;
      line-height: 28px;
      color: var(--text-secondary, #5A5F6B);
      word-break: break-word;
    }
  }
}
</style>
